import { type FC, useState, lazy, Suspense, useContext, type ComponentProps } from "react";
import { formStateContext } from "@legacy_root/client_frontend/components/pages/scouts/scouts_select_locations";
import {
  type thisFormStateProps,
  type CityProps,
  type LineProps,
} from "@legacy_root/client_frontend/components/pages/scouts/scouts_select_locations/src/city_and_station_modal/src/city_and_station_modal_props";
import { retryLazyLoad } from "@root/shared/utils/retryLazyLoad";
import * as styles from "./styles.css";
import type { CityAndStationModal as CityAndStationModalProps } from "./city_and_station_modal";

const CityAndStationModal = lazy(() =>
  retryLazyLoad<ComponentProps<typeof CityAndStationModalProps>>({
    fn: () =>
      import("./city_and_station_modal").then((module) => ({
        default: module.CityAndStationModal,
      })),
  }),
);

type Props = {
  stationFetchUrl: string;
  cityArray: CityProps[];
  lineArray: LineProps[];
  prefectureId: number;
  thisFormState: thisFormStateProps;
};

export const SelectedLists: FC<Props> = ({
  prefectureId,
  thisFormState,
  stationFetchUrl,
  cityArray,
  lineArray,
}) => {
  const { dispatchFormState } = useContext(formStateContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = useState({});

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);

  const deleteCity = (cityId: number) => {
    dispatchFormState({
      type: "unSelectCities",
      value: cityId,
      prefectureId,
    });
  };

  const deleteStation = (stationId: number) => {
    dispatchFormState({
      type: "unSelectStations",
      value: stationId,
      prefectureId,
    });
  };

  const deleteLine = (lineId: number) => {
    dispatchFormState({
      type: "unSelectLine",
      value: lineId,
      prefectureId,
    });
  };

  return (
    <>
      <Suspense fallback={null}>
        {thisFormState.name && (
          <CityAndStationModal
            thisFormState={thisFormState}
            prefectureId={prefectureId}
            cityArray={cityArray}
            lineArray={lineArray}
            stationFetchUrl={stationFetchUrl}
            closeModal={closeModal}
            setIsAccordionOpen={setIsAccordionOpen}
            isAccordionOpen={isAccordionOpen}
            isModalOpen={isModalOpen}
          />
        )}
      </Suspense>
      <ul className={styles.selectedLists}>
        {thisFormState.cities &&
          Object.keys(thisFormState.cities)
            .map(Number)
            .map((cityId) => (
              <li className={styles.selectedList} key={cityId}>
                <button
                  className={styles.cancelButton}
                  type="button"
                  onClick={() => deleteCity(cityId)}
                >
                  <i className="icon-cancel" />
                </button>
                {Object.values(thisFormState.cities[cityId])[0]}
              </li>
            ))}
        {thisFormState.stations &&
          Object.keys(thisFormState.stations)
            .map(Number)
            .map((stationId) => (
              <li className={styles.selectedList} key={stationId}>
                <button
                  className={styles.cancelButton}
                  type="button"
                  onClick={() => deleteStation(stationId)}
                >
                  <i className="icon-cancel" />
                </button>
                {Object.values(thisFormState.stations[stationId])[0]}駅
              </li>
            ))}
        {thisFormState.line &&
          !thisFormState.showStations &&
          Object.keys(thisFormState.line)
            .map(Number)
            .map((lineId) => (
              <li className={styles.selectedList} key={lineId}>
                <button
                  className={styles.cancelButton}
                  type="button"
                  onClick={() => deleteLine(lineId)}
                >
                  <i className="icon-cancel" />
                </button>
                {Object.values(thisFormState.line[lineId])[0]}
              </li>
            ))}
        <li>
          <button className={styles.openModalButton} type="button" onClick={openModal}>
            <i className="icon-plus-1" />
            エリア・駅を追加する
          </button>
        </li>
      </ul>
    </>
  );
};
